import * as React from "react";
import { useAppDispatch, useAppSelector } from "#store";
import { push } from "redux-first-history";
import { generateUrl } from "#components/App/routing/generateUrl";
import { generatePath } from "react-router";
import { Routes } from "#/config";
import { ActionType } from "#services/pilotService/types";
import { IconButton, Input, InputAdornment, Tooltip } from "@mui/material";
import { DoubleArrow, Search } from "@mui/icons-material";
import DatasourceSelector from "#components/DatasourceSelector";

export const QlInputComponent = () => {
    const [value, setValue] = React.useState("");
    const dispatch = useAppDispatch();
    const datasourceDto = useAppSelector(
        state => state.uiState.selectedDatasource
    );

    const onSubmit = (v: string) =>
        dispatch(
            push(
                generateUrl(generatePath(Routes.triggerAction.path), {
                    q: v,
                    op: ActionType.QL2DATA,
                    o: datasourceDto.queryLanguage,
                    db: datasourceDto.name,
                })
            )
        );

    return (
        <React.Fragment>
            {/*<TextareaAutosize*/}
            {/*    placeholder="Type a structured query (like SQL or SPARQL)"*/}
            {/*/>*/}
            <Input
                fullWidth
                multiline
                autoFocus
                value={value}
                placeholder="Type a structured query (like SQL or SPARQL)"
                onChange={evt => setValue(evt.target.value)}
                startAdornment={
                    <InputAdornment position="start">
                        <DoubleArrow />
                    </InputAdornment>
                }
                endAdornment={
                    <InputAdornment position="end">
                        <DatasourceSelector />
                        <Tooltip title="Start Search">
                            <IconButton onClick={() => onSubmit(value)}>
                                <Search />
                            </IconButton>
                        </Tooltip>
                    </InputAdornment>
                }
                inputProps={{
                    shrink: "true",
                }}
                sx={{
                    fontFamily: "monospace",
                }}
            />
        </React.Fragment>
    );
};
